import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";
import Select from "react-select";

const MetaBaseDashBoardSix = () => {
  const [ iframeUrl50, setIframeUrl50 ] = useState( "" );
  const [ iframeUrl51, setIframeUrl51 ] = useState( "" );
  const [ loading, setLoading ] = useState( false );
  const [ error, setError ] = useState( "" );
  const currentYear = () => new Date().getFullYear().toString();
  const [ selectedYear, setSelectedYear ] = useState( currentYear );
  const [ iframeUrlApi ] = useIframeUrlMutation();
  const years = Array.from({ length: 16 }, (_, i) => { const year = (2025 + i).toString();
    return { value: year, label: year };
  });

  const fetchDashboards = async () => {
    if ( !selectedYear ) return;

    setLoading( true );
    setError( "" );

    const payload = {
      Year: selectedYear,
    };

    try {
      const [ res50, res51 ] = await Promise.all( [
        iframeUrlApi( {
          questionId: 54,
          params: payload,
          expMinutes: 10,
          bordered: true,
          titled: true,
        } ).unwrap(),

        iframeUrlApi( {
          questionId: 55,
          params: payload,
          expMinutes: 10,
          bordered: true,
          titled: true,
        } ).unwrap(),
      ] );

      setIframeUrl50( res50.iframeUrl );
      setIframeUrl51( res51.iframeUrl );
    } catch {
      setError( "Failed to load dashboards" );
    } finally {
      setLoading( false );
    }
  };

  useEffect( () => {
    fetchDashboards();
  }, [ selectedYear ] );

  const handleReload = () => {
    setSelectedYear( currentYear );
  };

  return (
    <div style={ { padding: "20px" } }>
      <div className="iframe-card iframe-card-filter-sec" style={ { marginBottom: "16px" } }>
        <div className="iframe-card-filter">
          <label style={ { display: "block", marginBottom: "4px" } }>
            Select Year
          </label>

          <Select
            value={years.find(y => y.value === selectedYear)}
            onChange={(option) => setSelectedYear(option.value)}
            options={years}
            styles={{
              menu: (base) => ({
                ...base,
                maxHeight: 160,     
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: 160,
                overflowY: "auto", 
              }),
            }}
          />
        </div>

        <button
          onClick={ handleReload }
          disabled={ loading }
          className="btn success-btn reload-btn"
          style={ { marginLeft: "12px" } }
        >
          Reload Current Year
        </button>
      </div>

      { loading && <p>Loading dashboards...</p> }
      { error && <p style={ { color: "red" } }>{ error }</p> }

      <div
        style={ {
          display: "flex",
          gap: "20px",
          marginTop: "20px",
          flexWrap: "wrap",
        } }
      >
        <div style={ { flex: 1, minWidth: "450px" } }>
          { iframeUrl50 ? (
            <iframe
              src={ iframeUrl50 }
              width="100%"
              height="500"
              frameBorder="0"
              style={ { borderRadius: "8px" } }
              title="Dashboard 50"
            />
          ) : (
            <p>No data for Dashboard 50</p>
          ) }
        </div>

        <div style={ { flex: 1, minWidth: "450px" } }>
          { iframeUrl51 ? (
            <iframe
              src={ iframeUrl51 }
              width="100%"
              height="500"
              frameBorder="0"
              style={ { borderRadius: "8px" } }
              title="Dashboard 51"
            />
          ) : (
            <p>No data for Dashboard 51</p>
          ) }
        </div>
      </div>
    </div>
  );
};

export default MetaBaseDashBoardSix;
